var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecurringIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(-92 -242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 14,
    height: 14,
    rx: 7,
    transform: "translate(92 242)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(94.673 205.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M2.568,43.865a.213.213,0,0,0-.16-.353H1.861c0-.054-.006-.109-.006-.164a2.471,2.471,0,0,1,4.166-1.8l.771-.9a3.657,3.657,0,0,0-6.123,2.7c0,.055,0,.109,0,.164H.213a.213.213,0,0,0-.16.353l1.04,1.192.218.25.784-.9Z",
    transform: "translate(0)",
    fill: "#a1f3b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M127.519,161.628l-.775-.889-.483-.553-.689.79-.569.653a.213.213,0,0,0,.16.353h.546a2.471,2.471,0,0,1-3.979,1.78l-.771.9a3.657,3.657,0,0,0,5.938-2.682h.461A.213.213,0,0,0,127.519,161.628Z",
    transform: "translate(-118.918 -118.459)",
    fill: "#a1f3b5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringIcon);
export default __webpack_public_path__ + "static/media/recurringIcon.9f095a3f53313daca865a634c98f0642.svg";
export { ForwardRef as ReactComponent };